import { useCallback, useEffect, useState } from "react";
import { AppShell } from "../app/AppShell";
import { Alert, Loading } from "../components/Card";
import { PageHead } from "../components/Page";
import { CopyLinkButton, IssueDetailBody, issueHref } from "../components/IssueDetail";
import type { Issue, Milestone } from "../lib/tasks";
import { errText, tasksApi } from "../lib/tasks";
import { routeParam } from "../lib/route";
import { tx } from "../i18n";

/* ══ 이슈 상세 전체 화면(`#/issue?id=`) — 모달과 **같은 몸통**(IssueDetailBody)을 판 위에 펼친다 ══
   주소로 공유할 때 · 칸이 많아 모달이 좁을 때 쓴다. 다른 이슈로 갈 때는 주소를 바꾼다(모달과 달리 여기는
   화면이라 뒤로 가기가 브라우저 몫이다). 내비는 보드에 서 있다 — 이슈는 작업 그룹의 것이다. */
export function IssuePage() {
  const [id, setId] = useState(() => routeParam("id"));
  const [list, setList] = useState<Issue[] | null>(null);
  const [ms, setMs] = useState<Milestone[]>([]);
  const [err, setErr] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const [ts, m] = await Promise.all([tasksApi.list(), tasksApi.milestones()]);
      setList(ts);
      setMs(m);
      setErr(null);
    } catch (e) {
      setErr(errText(e));
    }
  }, []);

  useEffect(() => {
    void load();
    const onHash = () => setId(routeParam("id"));
    addEventListener("hashchange", onHash);
    return () => removeEventListener("hashchange", onHash);
  }, [load]);

  const t = list?.find((x) => x.id === id) ?? null;
  const open = (next: string) => {
    location.hash = issueHref(next);
  };

  return (
    <AppShell route="/board">
      <PageHead title={t ? t.title : tx("issueDetail.page")} />
      {err ? <Alert tone="error">{tx("issueDetail.loadFailed", { err })}</Alert> : null}
      {!list && !err ? <Loading text={tx("common.state.loading")} /> : null}
      {list && !t ? <Alert tone="warning">{tx("issueDetail.notFound", { id: id ?? "" })}</Alert> : null}
      {list && t ? (
        <>
          <IssueDetailBody
            t={t}
            all={list}
            onOpen={open}
            epicTitle={t.parentId ? list.find((x) => x.id === t.parentId)?.title : undefined}
            milestoneLabel={t.milestoneId ? ms.find((m) => m.id === t.milestoneId)?.title : undefined}
            onChanged={() => void load()}
            onDeleted={() => {
              location.hash = "#/board";
            }}
          />
          <div className="idetail-page__foot">
            <CopyLinkButton id={t.id} />
            <a className="b-btn b-btn-ghost b-btn-sm" href="#/board">
              {tx("issueDetail.toBoard")}
            </a>
          </div>
        </>
      ) : null}
    </AppShell>
  );
}
